//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select, cancel, cancelled } from "redux-saga/effects";
import { delay } from "redux-saga";
import { TreeFlatener, TreeMap, cloneAsync, AsyncSaga, number, DateTime, string, array, persist } from "../../utils";
import config from "../../boot/config";
import pointservice from "../../services/points";
import rulesservice from "../../services/rules";
import sitesservice from "../../services/sites";
import ticketservice from "../../services/ticket";
import { types as sitetreetypes } from "../../services/SiteTree/redux";
import { types as logintypes } from "../Login/redux";
import moment from "moment-timezone";

import timezone from "../../utils/timezone";

const LIVE_DATA_INTERVAL = 5000;
const SITE_PAGE_TABLE_CONFIG = "sitePageTableConfig";
const dataTypes = [{ name: "Live" }, { name: "Historical" }];

const initialState = {
   viewSelected: null,
   views: new TreeMap(),
   // sitesDataViewsMap: new TreeMap(),

   viewType: "grid",
   sites: [],
   sitesMap: new TreeMap(),

   dataType: "Live",
   columnConf: { columns: [], fetched: false },

   onPage: false,

   time: {
      startDate: DateTime.startOf("day"),
      endDate: DateTime.endOf("day"),
      key: "selection"
   },

   isBusy: true,
   errors: [],
   isMouseIn: false,
   mouseSite: null,
   mouseX: 0,
   mouseY: 0,
   mouseSiteFailList: [],
};

const persistConf = {
	whitelist: ["views", "viewSelected", "viewType", "time", "dataType"],
	expireInNumHours: 24 * 7 //1 week
};

/////////
//types
export const types = {
   //site map is tree of all data views
   // SET_SITE_MAP: "screens/home/SET_SITE_MAP",
   // SET_SITE_MAP_FAILED: "screens/home/SET_SITE_MAP_FAILED",

   //set view type to list grid
   TOGGLE_SCREEN_VIEW: "screens/home/TOGGLE_SCREEN_VIEW",
   TOGGLE_DATA_TYPE: "screens/home/TOGGLE_DATA_TYPE",

   //set list for dropdown
   SET_VIEWS: "screens/home/SET_VIEWS",

   //gotten data view tree
   SET_SITES: "screens/home/SET_SITES",
   //gotten site live data based on points data view tree
   SET_SITE_LIVE_DATA: "screens/home/SET_SITE_LIVE_DATA",
   SET_SITE_LIVE_DATA_ALT: "screens/home/SET_SITE_LIVE_DATA_ALT",
   ON_SET_SITE_LIVE_DATA_FAILED: "screens/home/ON_SET_SITE_LIVE_DATA_FAILED",
   CHANGE_TIME: "screens/home/CHANGE_TIME",

   //current site
   SET_CURRENT_VIEW: "screens/home/SET_CURRENT_VIEW",

   //delete sites array
   CLEAR_SITES: "screens/home/CLEAR_SITES",

   //set column/api conf
   SET_COLUMN_CONFIGURATION: "screens/home/SET_COLUMN_CONFIGURATION",

   START_LIVE_DATA: "screens/home/START_LIVE_DATA",
   STOP_LIVE_DATA: "screens/home/STOP_LIVE_DATA",

   NEW_AMBIENT_MAX: "screens/home/NEW_AMBIENT_MAX",
   NEW_AMBIENT_MIN: "screens/home/NEW_AMBIENT_MIN",
   SET_AMBIENT_MAX: "screens/home/SET_AMBIENT_MAX",
   SET_AMBIENT_MIN: "screens/home/SET_AMBIENT_MIN",

   MOUSE_ENTER_CIRCLE: "screens/home/MOUSE_ENTER_CIRCLE",
   MOUSE_LEAVE_CIRCLE: "screens/home/MOUSE_LEAVE_CIRCLE",
   MOUSE_MOVE_CIRCLE: "screens/home/MOUSE_MOVE_CIRCLE",
   SET_MOUSE_SITE_FAIL_LIST: "screens/home/SET_MOUSE_SITE_FAIL_LIST",
   SET_MOUSE_SITE_FAIL_LIST_FAILED: "screens/home/SET_MOUSE_SITE_FAIL_LIST_FAILED",
   SET_SITE_DATA: "screens/home/SET_SITE_DATA",

	CHANGE_VIEW: "screens/home/CHANGE_VIEW",

   RESET_MOUSE: "screens/home/RESET_MOUSE",
};

///////////
//reducers
const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {
         // case types.SET_SITE_MAP:
         //    return { ...state, sitesDataViewsMap: action.payload.map };
         // case types.SET_SITE_MAP_FAILED:
         //    return { ...state, errors: state.errors.concat(action.payload).slice(-10) };

         case types.TOGGLE_SCREEN_VIEW:
            return { ...state, viewType: action.payload.type };
         case types.TOGGLE_DATA_TYPE:
            return { ...state, dataType: action.payload.type, isBusy: action.payload.type !== state.dataType };

         case types.START_LIVE_DATA:
            return { ...state, onPage: true };
         case types.STOP_LIVE_DATA:
            return { ...state, onPage: false };

            case types.MOUSE_ENTER_CIRCLE:
                  return { ...state, isMouseIn: true, mouseSite: action.payload.site, mouseX: action.payload.evt.target.pageX, mouseY: action.payload.evt.target.pageY, mouseSiteFailList: []}
            case types.MOUSE_LEAVE_CIRCLE:
                  return { ...state, isMouseIn: false, mouseSite: null, mouseSiteFailList: [] }
            case types.MOUSE_MOVE_CIRCLE:
                  return { ...state, isMouseIn: state.mouseSiteFailList.length > 0, mouseX: action.payload.evt.x, mouseY: action.payload.evt.y}
            case types.SET_MOUSE_SITE_FAIL_LIST:
                  return { ...state, mouseSiteFailList: action.payload }
            case types.RESET_MOUSE:
                  return { ...state, isMouseIn: false, mouseSite: null, mouseSiteFailList: []}

         case types.CHANGE_TIME:
            return { ...state, isBusy: action.payload.time !== state.time, time: action.payload.time };

         case types.SET_CURRENT_VIEW:
            return {
               ...state,
               isBusy: action.payload.value._tree.children.length > 0 ? state.isBusy : true,
               viewSelected: action.payload.value._tree.children.length > 0 ? state.viewSelected : action.payload.value
            };
         case types.SET_VIEWS:
            return { ...state, views: action.payload.map };

         case types.SET_COLUMN_CONFIGURATION:
            return { ...state, columnConf: action.payload.conf };

         case types.CLEAR_SITES:
            return { ...state, sites: [], ambientMax: undefined, ambientMin: undefined };

         case types.SET_SITES:
            return { ...state, isBusy: true, sitesMap: action.payload.sitesMap };
            case types.SET_SITE_DATA:
                  return { ...state, sites: action.payload};
         case types.SET_SITE_LIVE_DATA:
            return { ...state, sites: action.payload.sites, isBusy: false };
         case types.SET_SITE_LIVE_DATA_ALT:
            return { ...state, sites: action.payload.sites };
         case types.ON_SET_SITE_LIVE_DATA_FAILED:
            return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };

            case types.SET_AMBIENT_MAX:
                  return { ...state, ambientMax: action.payload }
            case types.SET_AMBIENT_MIN:
                  return { ...state, ambientMin: action.payload }

			case types.CHANGE_VIEW:
         default:
            return state;
      }
   }
};
export const reducer = persist("sites", reducers.reducer, persistConf);


//////////
//sagas
export const sagas = {
*rootSaga() {
      yield all([
            this.onChangeView(),
            this.onGetViews(),
            this.onChangeDataType(),
            this.setColumnConf(),
            this.updateLiveData.bind(this)(),
            this.onNewAmbientMax(),
            this.onNewAmbientMin(),
            this.onMouseEnterCircle(),
            this.onMouseLeaveCircle(),
            this.onMouseMoveCircle(),
            ]);
      },

      *onMouseEnterCircle() {
            yield takeEvery(types.MOUSE_ENTER_CIRCLE, function*({payload}) {
                  payload.evt.persist();
                  yield delay(10);
                  if(payload.site.failedRules > 0) {
                        const isMenuOpen = yield select(x => x.menu.isOpen);
                        let doc = document.getElementById("sites-tooltip");
                        const flattenedSiteTree = yield select(x => x.sitetree.flattenedSiteTree);
                        var tzone = flattenedSiteTree[payload.site._tree.own].momentTimezone;
                        var toDate = moment().tz(tzone);
                        if(doc && toDate) {
                              const top = payload.evt.pageY + 20;
                              const left = payload.evt.pageX - (isMenuOpen ? 200 : 0);
                              doc.setAttribute("style", "top: " + top + "px; left: " + left + "px;");

                              const list = yield call(rulesservice.GetFailedRuleInstanceOutcomesBySiteName, payload.site.name, toDate);
                              if(list instanceof Error) {
                                    yield put(actions.genericAction(types.SET_MOUSE_SITE_FAIL_LIST_FAILED, list));
                                    yield put(actions.setMouseSiteFailList([]));
                              } else {
                                    yield put(actions.setMouseSiteFailList(list));
                              }
                        } else {
                              yield put(actions.resetMouse());
                        }
                  }
            });
      },
      *onMouseLeaveCircle() {
            yield takeEvery(types.MOUSE_LEAVE_CIRCLE, function({payload}) {
                  payload.evt.persist();
                  let doc = document.getElementById("sites-tooltip");
                  if(doc) {
                        doc.setAttribute("style", "visibility: hidden");
                  }
            });
      },
      *onMouseMoveCircle() {
            yield takeEvery(types.MOUSE_MOVE_CIRCLE, function*({payload}) {
                  payload.evt.persist();
			yield delay(10);
                  if(payload.site.failedRules > 0) {
                        const isMenuOpen = yield select(x => x.menu.isOpen);
                        let doc = document.getElementById("sites-tooltip");
                        if(doc) {
                              const top = payload.evt.pageY + 20;
                              const left = payload.evt.pageX - (isMenuOpen ? 200 : 0);
                              doc.setAttribute("style", "top: " + top + "px; left: " + left + "px;");
                        }
                  }
            });
      },
      
      *onNewAmbientMax() {
            yield takeEvery(types.NEW_AMBIENT_MAX, function*({payload}) {
                  if(!payload || isNaN(payload)) {
                        return;
                  }
                  const oldAmbientMax = yield select(x => x.sites.ambientMax);

                  if(!oldAmbientMax || payload > oldAmbientMax) {
                        yield put(actions.setAmbientMax(payload));
                  }
            });
      },

      *onNewAmbientMin() {
            yield takeEvery(types.NEW_AMBIENT_MIN, function*({payload}) {
                  if(!payload || isNaN(payload)) {
                        payload = 0;
                  }
                  const oldAmbientMin = yield select(x => x.sites.ambientMin);

                  if(!oldAmbientMin || payload < oldAmbientMin) {
                        yield put(actions.setAmbientMin(payload));
                  }
            });
      },

   *setColumnConf() {
      const currentDetails = yield select(x => x.login.currentDetails);
      let _conf = currentDetails.config;
      if (!_conf) {
         const result = yield take([logintypes.STORE_DETAILS, logintypes.ON_LOGIN_FAILED]);
         if (result.type === logintypes.ON_LOGIN_FAILED) {
            return;
         }
         _conf = result.payload.data.config;
      }

      const columnConf = _conf[SITE_PAGE_TABLE_CONFIG] ? JSON.parse(_conf[SITE_PAGE_TABLE_CONFIG].configJson, string.toCamelCase) : {};

      columnConf.fetched = true;

      yield put(actions.setColumnConf(columnConf));
   },

   *updateLiveData() {
      for (;;) {
         yield delay(LIVE_DATA_INTERVAL);
         const state = yield select(x => x.sites);
         if (state.viewType === "list" && state.dataType === "Live" && state.onPage) {
            const datamap = state.sitesMap;
            const sites = datamap.Roots;
            if (sites.length > 0 && !this._gettingLive) {
               this._gettingLive = true;
               this._onChangeDataTypeTask = yield fork(this.getData.bind(this), datamap);
            }
         }
      }
   },

   *getData(datamap, isHistorical, time) {
      let columnConf = yield select(x => x.sites.columnConf);
      if (!columnConf.fetched) {
         const s = yield take(types.SET_COLUMN_CONFIGURATION);
         columnConf = s.payload.conf;
      }

      const asyncsaga = new AsyncSaga();
      const failedRulesSaga = new AsyncSaga();

      //get all data points
      let sites = datamap.Roots;

      //the name of the specific views that contain the meters for a datapoint
      const viewsToFetch = datamap.Where(x => columnConf.columns.find(s => s.meterName === x.name && !s.endpointName));
      const calcViewsToFetch = datamap.Where(x => columnConf.columns.find(s => s.endpointName === x.name));
      let metersToFetch = [];
      let calcMetersToFetch = [];


      /**********    api overrides    ***************** */
      const apisToCall = columnConf.columns.filter(s => s.endpointName && !s.meter && s.show);

      //call remaining apis
      for (let index = 0; index < apisToCall.length; index++) {
         const conf = apisToCall[index];
         if(conf.endpointName === "failedRules") {
            yield call(callApi, failedRulesSaga, conf, sites, isHistorical, { time });
         }
      }

      for(
         let failedForkResult = yield call(failedRulesSaga.ReadResult);
         failedForkResult;
         failedForkResult = yield call(failedRulesSaga.ReadResult)
      ) {
         if(failedForkResult.data instanceof Error) {
            console.warn(failedForkResult.id + " failed to load.");
            yield put(actions.genericAction(types.ON_SET_SITE_LIVE_DATA_FAILED, failedForkResult.data));
         } else {
            const result = failedForkResult.data;

            if(failedForkResult.id === "Call_GetFailedRulesForSites") {
               for (let i = 0; i < sites.length; i++) {
                  //generic prop assignment. result from http call will be added, so long as column 'conf' object is the last arg in failedForkResult.args[]
                  const siteX = sites[i];
                  const argsX = failedForkResult.args[failedForkResult.args.length - 1];
                  siteX[(argsX.prop || argsX).propName] = result[siteX.name.toLowerCase()];
               }
            }
         }
      }

      failedRulesSaga.End();
      yield put(actions.setSiteLiveDataAlt(sites.filter(x => !x.name.startsWith("000AAA"))));


      for (let index = 0; index < apisToCall.length; index++) {
         const conf = apisToCall[index];
         if(conf.endpointName !== "failedRules") {
            yield call(callApi, asyncsaga, conf, sites, isHistorical, { time });
         }
      }
      /**********    iEnergy Meter calls    ***************** */

      //loop thru each view and find the first view under 'Main' that has no children. this is the meter
      for (let index = 0; index < columnConf.columns.length; index++) {
         const prop = columnConf.columns[index];
         //get calculation meters
         const calcViews = calcViewsToFetch.filter(x => x.name === prop.endpointName);
         for (let ci = 0; ci < calcViews.length; ci++) {
            const calcView = calcViews[ci];
            let main = datamap.GetChildrenFor(calcView).find(x => x.name === "Main");
            if (!main) {
               main = calcView;
            }
            const dataMeter = main;
            prop.meter = true;
            const site = datamap.GetRootFor(main);
            calcMetersToFetch.push({ dataMeter, prop, calcView, site });
         }

         //get meters
         const views = viewsToFetch.filter(x => x.name === prop.meterName);
         for (let vi = 0; vi < views.length; vi++) {
            const view = views[vi];
            let main = datamap.GetChildrenFor(view).find(x => x.name === "Main");
            if (!main) {
               main = view;
            }
            const dataMeter = main;
            const prop = columnConf.columns.find(s => s.meterName === view.name);
            prop.meter = true;
            const site = datamap.GetRootFor(main);
            metersToFetch.push({ dataMeter, prop, view, site });
         }
      }

      if (isHistorical) {
         if (metersToFetch.length) {
            yield asyncsaga.fork(
               "Call_MeterVals",
               pointservice.TrendableDataGetData,
               metersToFetch.map(x => x.dataMeter.objectID).join(","),
               moment(time.startDate),
               moment(time.endDate),
               AsyncSaga.END_OF_ARGS,
               metersToFetch
            );
         }
      } else {
         if (metersToFetch.length) {
            yield asyncsaga.fork(
               "Call_MeterVals",
               pointservice.LiveDataGet,
               metersToFetch.map(x => x.dataMeter.objectID).join(","),
               AsyncSaga.END_OF_ARGS,
               metersToFetch
            );
         }
      }

      if (calcMetersToFetch.length) {
         let calcMetersGrouped = array.groupBy(calcMetersToFetch, x => x.prop.endpointName);
         yield call(callConfMeter, asyncsaga, calcMetersGrouped, isHistorical, { time });
      }

      /**********    our api calls    ***************** */
      //get any data from our api for all sites
      if (isHistorical) {
         yield asyncsaga.fork(
            "Call_GetDataForSites",
            sitesservice.GetDataForSites,
            sites.map(x => x.name.toLowerCase()),
            DateTime.toISOstring(time.startDate),
            DateTime.toISOstring(time.endDate)
         );
      } else {
         yield asyncsaga.fork(
            "Call_GetDataForSites",
            sitesservice.GetDataForSites,
            sites.map(x => x.name.toLowerCase())
         );
      }
      /**********   results    ***************** */
      //now get the results from all teh calls
      for (
         let forkResult = yield call(asyncsaga.ReadResult);
         forkResult;
         forkResult = yield call(asyncsaga.ReadResult)
      ) {
         if (forkResult.data instanceof Error) {
            console.warn(forkResult.id + " failed to load.");
            yield put(actions.genericAction(types.ON_SET_SITE_LIVE_DATA_FAILED, forkResult.data));
         } else {
            const result = forkResult.data;

            //process results
            if (forkResult.id === "Call_MeterVals") {
               const args = forkResult.args[2];
               //map to each site/column
               for (let index = 0; index < args.length; index++) {
                  const arg = args[index];
                  const data = result[arg.dataMeter.objectID];
                  let site = arg.site;
                  site[arg.prop.propName] = isHistorical === true
                     ? data.reduce((prev, curr) => prev + curr.value, 0)
                     : data.value;
               }
            } else if (forkResult.id === "Call_GetDataForSites") {
               for (let i = 0; i < sites.length; i++) {
                  //merge in all data from our api
                  const site = sites[i];
                  sites[i] = { ...site, ...result[site.name.toLowerCase()] };
               }
            } else if (forkResult.id === "Call_TrendableDataGetData_Minimum") {
               const args = forkResult.args[forkResult.args.length - 1];
               let min = Number.MAX_VALUE;
               for (let index = 0; index < args.length; index++) {
                  const arg = args[index];
                  const site = arg.site;
                  const meter = arg.dataMeter;

                  let resultData; 
                  if (args.length > 1) {
                     resultData = result[meter.objectID];
                  } else {
                     resultData = result;
                  }

                  if (resultData.length > 0) {
                        site.ambientMin = resultData.reduce(function(a, b) { return a.value <= b.value ? a : b}, {value: Number.MAX_VALUE}).value;
                        if(site.ambientMin === Number.MAX_VALUE || site.ambientMin > 1000) {
                              site.ambientMin = 0;
                        }
                        if(site.ambientMin < min) {
                              min = site.ambientMin;
                        }
                  }
               }
               yield put(actions.newAmbientMin(min));
            } else if (forkResult.id === "Call_TrendableDataGetData_Maximum") {
               const args = forkResult.args[forkResult.args.length - 1];
               let max = 0;
               for (let index = 0; index < args.length; index++) {
                  const arg = args[index];
                  const site = arg.site;
                  const meter = arg.dataMeter;

                  let resultData;
                  if (args.length > 1) {
                     resultData = result[meter.objectID];
                  } else {
                     resultData = result;
                  }
                  if (resultData.length > 0) {
                     site.ambientMax = resultData.reduce(
                           function(a, b) { 
                                 return a.value >= b.value ? a : b
                              }, {value: 0}).value;

                        if(site.ambientMax > max) {
                              max = site.ambientMax;
                        }
                  }
               }
               yield put(actions.newAmbientMax(max));
            } else if (forkResult.id === "Call_LiveDataGetRollingHour") {
               const args = forkResult.args[forkResult.args.length - 1];
               for (let index = 0; index < args.length; index++) {
                  const arg = args[index];
                  const site = arg.site;
                  const meter = arg.dataMeter;

                  const resultData = result[meter.objectID];;

                  if (resultData) {
                     site[arg.prop.propName] = resultData.value;
                  }
               }
            } else if (forkResult.id === "Call_TrendableDataGetData_PerSite") {
               const args = forkResult.args[forkResult.args.length - 1];
               for (let index = 0; index < args.length; index++) {
                  const arg = args[index];
                  const site = arg.site;
                  const meter = arg.dataMeter;
                  let value = 0;

                  let resultData;
                  if (args.length > 1) {
                     resultData = result[meter.objectID];
                  } else {
                     resultData = result;
                  }

                  if (Array.isArray(resultData)) {
                     value = resultData.reduce((prev, curr) => prev + curr.value, 0);
                  } else {
                     for (let p in resultData) {
                        if (resultData.hasOwnProperty(p)) {
                           value += resultData[p].reduce((prev, curr) => prev + curr.value, 0);
                        }
                     }
                  }
                  site[arg.prop.propName] = value;
               }
            } else {
               for (let i = 0; i < sites.length; i++) {
                  //generic prop assignment. result from http call will be added, so long as column 'conf' object is the last arg in forkResult.args[]
                  const siteX = sites[i];
                  const argsX = forkResult.args[forkResult.args.length - 1];
                  siteX[(argsX.prop || argsX).propName] = result[siteX.name.toLowerCase()];
               }
            }
         }
      }

      asyncsaga.End();

      this._gettingLive = false;
      if (!(yield cancelled())) {
         yield put(actions.setSiteLiveData(sites.filter(x => !x.name.startsWith("000AAA")))); //remove template views
      }
   },

   *onChangeDataType() {
      yield takeEvery(
         [types.SET_SITES, types.TOGGLE_DATA_TYPE, types.CHANGE_TIME],
         function*(action) {
            const state = yield select(x => x.sites);

            yield put(actions.clearSites());

            if (this._onChangeDataTypeTask) {
               yield cancel(this._onChangeDataTypeTask);
               this._onChangeDataTypeTask = null;
            }

            if (state.dataType === "Historical" && state.viewType === "list") {
               this._onChangeDataTypeTask = yield fork(this.getData.bind(this), state.sitesMap, true, state.time);
            } else if (state.dataType === "Live" && state.viewType === "list") {
               this._onChangeDataTypeTask = yield fork(this.getData.bind(this), state.sitesMap, false);
            } else if(state.viewType === "grid") {
                  yield put(actions.setSiteData(state.sitesMap.Roots));
                  this._onChangeDataTypeTask = yield fork(this.getData.bind(this), state.sitesMap, false);
            }
         }.bind(this)
      );
   },

   *onGetViews() {
      yield takeEvery(sitetreetypes.SET_FLATTENED_MENU_TREE, function*({ payload }) {
         const newMap = yield call(cloneAsync, payload.flattenedMenuTree);
			newMap.DeleteBranchs(newMap.Where(x => !x._tree.HasChildren));
			const existing = yield select(x => x.sites.viewSelected)
         if(!existing) yield put(actions.setView(newMap.First(x => !x._tree.HasChildren)));
			yield put(actions.setViews(newMap));
			const currentView = yield select(x => x.sites.viewSelected)
         yield put(actions.changeView(currentView));
      });
   },

   *onChangeView() {
      yield takeEvery([types.CHANGE_VIEW, types.SET_CURRENT_VIEW], function*({ payload }) {
         if (!payload.value._tree.HasChildren) {
            const sites = yield call(pointservice.TrendableObjectGetChildrenFor, payload.value.objectID);

            let sitesDataMap = yield select(x => x.sitetree.flattenedSiteTree);

            if (!sitesDataMap.Roots || sitesDataMap.Roots.length === 0) {
               //this ran before sitesmap was first built. wait for it
               const _action = yield take([
                  sitetreetypes.SET_FLATTENED_SITE_TREE,
                  sitetreetypes.SET_FLATTENED_SITE_TREE_FAILED
               ]);
               if (_action.type === sitetreetypes.SET_FLATTENED_SITE_TREE_FAILED) {
                  console.error("Site map missing. cannot get data for sites");
                  return;
               }
               sitesDataMap = _action.payload.flattenedSiteTree;
            }

            //this map contains the sites and then all the data points for them as children
            let datamap = TreeFlatener.Flatten(sites);

            for (let i = 0; i < sites.length; i++) {
                  const site = sites[i];
                  const siteData = sitesDataMap.First(x => x.name === site.name);

                  if(siteData) {
                        yield call(TreeFlatener.CopyBranchAsync, siteData, sitesDataMap, datamap, site);
                  }
            }
            
            //let datamap = yield call(cloneAsync, sitesDataMap);
            yield put(actions.setSites(datamap));
         }
      });
   }
};

////////
//actions
export const actions = {
   changeView(value) {
      return {
         type: types.CHANGE_VIEW,
         payload: { value }
      };
	},
	
	setView(value) {
      return {
         type: types.SET_CURRENT_VIEW,
         payload: { value }
      };
   },

   setSiteMap(map) {
      return {
         type: types.SET_SITE_MAP,
         payload: { map }
      };
   },

   setViews(map) {
      return {
         type: types.SET_VIEWS,
         payload: { map }
      };
   },

   setSites(sitesMap) {
      return {
         type: types.SET_SITES,
         payload: { sitesMap }
      };
   },

   setSiteLiveData(sites) {
      return {
         type: types.SET_SITE_LIVE_DATA,
         payload: { sites }
      };
   },

   setSiteLiveDataAlt(sites) {
      return {
         type: types.SET_SITE_LIVE_DATA_ALT,
         payload: { sites }
      };
   },

   setColumnConf(conf) {
      return {
         type: types.SET_COLUMN_CONFIGURATION,
         payload: { conf }
      };
   },

   toggleView(type) {
      return {
         type: types.TOGGLE_SCREEN_VIEW,
         payload: { type }
      };
   },
   toggleDataType(type) {
      return {
         type: types.TOGGLE_DATA_TYPE,
         payload: { type }
      };
   },
   changeTime(time) {
      return {
         type: types.CHANGE_TIME,
         payload: { time: time.selection }
      };
   },
   startLiveData() {
      return {
         type: types.START_LIVE_DATA,
         payload: {}
      };
   },
   stopLiveData() {
      return {
         type: types.STOP_LIVE_DATA,
         payload: {}
      };
   },

   clearSites() {
      return {
         type: types.CLEAR_SITES,
         payload: {}
      };
   },
   setSiteData(payload) {
         return {
               type: types.SET_SITE_DATA,
               payload
         }
   },

   mouseEnterCircle(evt, site) {
         return {
               type: types.MOUSE_ENTER_CIRCLE,
               payload: {evt, site}
         }
   },
   mouseLeaveCircle(evt, site) {
         return {
               type: types.MOUSE_LEAVE_CIRCLE,
               payload: {evt, site}
         }
   },
   mouseMoveCircle(evt, site) {
         return {
               type: types.MOUSE_MOVE_CIRCLE,
               payload: {evt, site}
         }
   },
   setMouseSiteFailList(payload) {
      return {
            type: types.SET_MOUSE_SITE_FAIL_LIST,
            payload
      }
   },


   newAmbientMax(payload) {
         return {
               type: types.NEW_AMBIENT_MAX,
               payload
         }
   },
   newAmbientMin(payload) {
         return {
               type: types.NEW_AMBIENT_MIN,
               payload
         }
   },
   setAmbientMax(payload) {
         return {
               type: types.SET_AMBIENT_MAX,
               payload
         }
   },
   setAmbientMin(payload) {
         return {
               type: types.SET_AMBIENT_MIN,
               payload
         }
   },
   resetMouse() {
      return {
            type: types.RESET_MOUSE,
      }
   },

   genericAction(type, data) {
      return {
         type,
         payload: data
      };
   }
};

function setValue(item, propPath, value) {
   if (typeof propPath === "string") {
      propPath = propPath.split(",");
   }

   const propName = propPath[0];

   if (propPath.length > 1) {
      item[propName] = {};
      setValue(item[propName], propPath.slice(1));
   } else {
      item[propName] = value;
   }
}

function* callApi(asyncsaga, conf, sites, isHistorical, args = {}) {
   if (!isHistorical) {
      switch (conf.endpointName) {
         case "numTickets":
            yield asyncsaga.fork(
               "Call_TicketLive",
               ticketservice.GetLiveSnapshot,
               sites.map(x => x.name.toLowerCase()),
               AsyncSaga.END_OF_ARGS,
               ...args,
               conf
            );
            break;
         case "failedRules":
            yield asyncsaga.fork(
               "Call_GetFailedRulesForSites",
               sitesservice.FailedRulesForSites,
               sites.map(x => x.name.toLowerCase()),
               AsyncSaga.END_OF_ARGS,
               ...args,
               conf
            );
            break;
         default:
            break;
      }
   } else {
      switch (conf.endpointName) {
         case "numTickets":
            yield asyncsaga.fork(
               "Call_TicketLive",
               ticketservice.GetTicketsSold,
               sites.map(x => x.name.toLowerCase()),
               DateTime.toISOstring(args.time.startDate),
               DateTime.toISOstring(args.time.endDate),
               true,
               AsyncSaga.END_OF_ARGS,
               ...args,
               conf
            );
            break;
         case "failedRules":
            yield asyncsaga.fork(
               "Call_GetFailedRulesForSites",
               sitesservice.FailedRulesForSitesHistorical,
               sites.map(x => x.name.toLowerCase()),
               DateTime.toISOstring(args.time.startDate),
               DateTime.toISOstring(args.time.endDate),
               AsyncSaga.END_OF_ARGS,
               ...args,
               conf
            );
            break;
         default:
            break;
      }
   }
}

function* callConfMeter(asyncsaga, groupedConfs, isHistorical, args = {}) {
      const flattenedSiteTree = yield select(x => x.sitetree.flattenedSiteTree);
   for (var p in groupedConfs) {
      if (groupedConfs.hasOwnProperty(p)) {
         if (!isHistorical) {
            switch (p) {
               case "DegC":
                  yield asyncsaga.fork(
                     "Call_TrendableDataGetData_Maximum",
                     pointservice.LiveDataGetRange,
                     groupedConfs[p].map(x => x.dataMeter.objectID).join(","),
                     DateTime.startOf("day"),
                     "Maximum",
                     AsyncSaga.END_OF_ARGS,
                     ...args,
                     groupedConfs[p]
                  );
                  yield asyncsaga.fork(
                     "Call_TrendableDataGetData_Minimum",
                     pointservice.LiveDataGetRange,
                     groupedConfs[p].map(x => x.dataMeter.objectID).join(","),
                     DateTime.startOf("day"),
                     "Minimum",
                     AsyncSaga.END_OF_ARGS,
                     ...args,
                     groupedConfs[p]
                  );
                  break;
               case "Meters":
                  const group = array.groupBy(groupedConfs[p], x => x.prop.calculation);

                  if (group.costPerHr && group.costPerHr.length) {
                     const groupTarif = array.groupBy(group.costPerHr, x => flattenedSiteTree[x.site._tree.own].tariffId);

                     for (var tarif in groupTarif) {
                        if (groupTarif.hasOwnProperty(tarif)) {
                           yield asyncsaga.fork(
                              "Call_LiveDataGetRollingHour",
                              pointservice.LiveDataGetRollingHour,
                              groupTarif[tarif].map(x => x.dataMeter.objectID).join(","),
                              tarif !== "undefined" ? tarif : null,
                              null,
                              true,
                              false,
                              null,
                              AsyncSaga.END_OF_ARGS,
                              ...args,
                              groupTarif[tarif]
                           );
                        }
                     }
                  }
                  if (group.spentToday && group.spentToday.length) {
                        
                        for (var site in group.spentToday) {
                              if (group.spentToday.hasOwnProperty(site)) {
                                    const tzone = flattenedSiteTree[group.spentToday[site].site._tree.own].momentTimezone;
                                    let tariffId = flattenedSiteTree[group.spentToday[site].site._tree.own].tariffId;
                                    let utcOffset = 0;
                                    if(tzone !== undefined && tzone !== null){
                                          utcOffset = moment().tz(tzone).utcOffset();
                                    }
                                    let startOf = moment().utc().add(utcOffset, 'm').startOf('day');
                                    let endOf = 'now';
                                    
                                    if(tariffId) {
                                       yield asyncsaga.fork(
                                             "Call_TrendableDataGetData_PerSite",
                                             pointservice.TrendableDataGetData,
                                             group.spentToday[site].dataMeter.objectID,
                                             startOf,
                                             endOf,
                                             tariffId !== undefined ? tariffId : null,
                                             null,
                                             "Daily",
                                             true,
                                             true, // exclude sub views
                                             undefined,
                                             AsyncSaga.END_OF_ARGS,
                                             ...args,
                                             [{...group.spentToday[site]}]
                                       );
                                    } else {
                                       console.error("No tariffId found");
                                    }
                              }
                        }
                  }
                  if (group.dailyTotal && group.dailyTotal.length) {
                        for(var daily in group.dailyTotal) {
                              if(group.dailyTotal.hasOwnProperty(daily)) {
                                    const tzone = flattenedSiteTree[group.dailyTotal[daily].site._tree.own].momentTimezone;
                                    let utcOffset = 0;
                                    if(tzone !== undefined && tzone !== null){
                                          utcOffset = moment().tz(tzone).utcOffset();
                                    }
                                    let startOf = moment().utc().add(utcOffset, 'm').startOf('day');
                                    let endOf = 'now';

                                    if(group.dailyTotal[daily].prop.propName === "co2") {
                                          yield asyncsaga.fork(
                                                "Call_TrendableDataGetData_PerSite",
                                                pointservice.TrendableDataGetDataEmissions,
                                                group.dailyTotal[daily].dataMeter.objectID,
                                                startOf,
                                                endOf,
                                                "Daily",
                                                true,
                                                true,
                                                flattenedSiteTree[group.dailyTotal[daily].site._tree.own].state,
                                                AsyncSaga.END_OF_ARGS,
                                                ...args,
                                                [group.dailyTotal[daily]]
                                          );
                                    } else {
                                          yield asyncsaga.fork(
                                                "Call_TrendableDataGetData_PerSite",
                                                pointservice.TrendableDataGetData,
                                                group.dailyTotal[daily].dataMeter.objectID,
                                                startOf,
                                                endOf,
                                                null,
                                                null,
                                                "Daily",
                                                true,
                                                true,
                                                undefined,
                                                AsyncSaga.END_OF_ARGS,
                                                ...args,
                                                [{...group.dailyTotal[daily]}]
                                          );
                                    }
                              }
                        }
                  }
                  break;
               default:
                  break;
            }
         } else {
            switch (p) {
               case "DegC":
                  yield asyncsaga.fork(
                     "Call_TrendableDataGetData_Maximum",
                     pointservice.TrendableDataGetData,
                     groupedConfs[p].map(x => x.dataMeter.objectID).join(","),
                     moment(args.time.startDate),
                     moment(args.time.endDate),
                     null,
                     null,
                     null,
                     false,
                     true,
                     "Maximum",
                     ...args,
                     AsyncSaga.END_OF_ARGS,
                     groupedConfs[p]
                  );
                  yield asyncsaga.fork(
                     "Call_TrendableDataGetData_Minimum",
                     pointservice.TrendableDataGetData,
                     groupedConfs[p].map(x => x.dataMeter.objectID).join(","),

                     moment(args.time.startDate),
                     moment(args.time.endDate),
                     null,
                     null,
                     null,
                     false,
                     true,
                     "Minimum",
                     ...args,
                     AsyncSaga.END_OF_ARGS,
                     groupedConfs[p]
                  );
                  break;
            case "Meters":
                  const group = array.groupBy(groupedConfs[p], x => x.prop.calculation);
                  
                  if (group.spentToday && group.spentToday.length) {
                     for (var site in group.spentToday) {
                        if (group.spentToday.hasOwnProperty(site)) {
                           let tariffId = flattenedSiteTree[group.spentToday[site].site._tree.own].tariffId;
                           
                           if(tariffId) {
                           yield asyncsaga.fork(
                                    "Call_TrendableDataGetData_PerSite",
                                    pointservice.TrendableDataGetData,
                                    group.spentToday[site].dataMeter.objectID,
                                    moment(args.time.startDate),
                                    moment(args.time.endDate),
                                    tariffId !== undefined ? tariffId : null,
                                    null,
                                    "Daily",
                                    true,
                                    true, // exclude sub views
                                    undefined,
                                    AsyncSaga.END_OF_ARGS,
                                    ...args,
                                    [{...group.spentToday[site]}]
                              );
                           }
                        }
                     }
                  }
                  if (group.dailyTotal && group.dailyTotal.length) {
                        for(var daily in group.dailyTotal) {
                              if(group.dailyTotal.hasOwnProperty(daily)) {
                                    if(group.dailyTotal[daily].prop.propName === "co2") {
                                          yield asyncsaga.fork(
                                                "Call_TrendableDataGetData_PerSite",
                                                pointservice.TrendableDataGetDataEmissions,
                                                group.dailyTotal[daily].dataMeter.objectID,
                                                moment(args.time.startDate),
                                                moment(args.time.endDate),
                                                "Daily",
                                                true,
                                                true,
                                                flattenedSiteTree[group.dailyTotal[daily].site._tree.own].state,
                                                AsyncSaga.END_OF_ARGS,
                                                ...args,
                                                [{...group.dailyTotal[daily]}]
                                          );
                                    } else {
                                          yield asyncsaga.fork(
                                                "Call_TrendableDataGetData_PerSite",
                                                pointservice.TrendableDataGetData,
                                                group.dailyTotal[daily].dataMeter.objectID,
                                                moment(args.time.startDate),
                                                moment(args.time.endDate),
                                                null,
                                                null,
                                                "Daily",
                                                true,
                                                true,
                                                undefined,
                                                AsyncSaga.END_OF_ARGS,
                                                ...args,
                                                [{...group.dailyTotal[daily]}]
                                          );
                                    }
                              }
                        }
                        
                  }
                  break;

               // case "costPerHr":
               //    {
               //       const groupTarif = array.groupBy(groupedConfs[p], x => x.site.tariffId);

               //       for (var tarif in groupTarif) {
               //          if (groupTarif.hasOwnProperty(tarif)) {
               //             yield asyncsaga.fork(
               //                "Call_TrendableDataGetData_PerSite",
               //                pointservice.TrendableDataGetData,
               //                groupTarif[tarif].map(x => x.dataMeter.objectID).join(","),
               //                moment(args.time.startDate),
               //                moment(args.time.endDate),
               //                tarif !== "undefined" ? tarif : null,
               //                "Hourly",
               //                AsyncSaga.END_OF_ARGS,
               //                ...args,
               //                groupTarif[tarif]
               //             );
               //          }
               //       }
               //    }
               //    break;
            default:
                  break;
            }
         }
      }
   }
}



// WEBPACK FOOTER //
// ./src/ui/Home/redux.js